module.exports = __webpack_public_path__ + "assets/img/img-wb-1da56a31.png";